import { render, staticRenderFns } from "./AddRecordOfAcheivement.vue?vue&type=template&id=04393461&"
import script from "./AddRecordOfAcheivement.vue?vue&type=script&lang=js&"
export * from "./AddRecordOfAcheivement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports